import React from 'react';
import { Skeleton } from '@mui/material';
import { BulletStatus } from 'components/bullet-status/bullet-status';
import {
    MarketingTransaction,
    MarketingTransactionStatus,
} from './marketing-transaction.types';
import { BulletStatusProps } from 'components/bullet-status/types';
import { getMarketingTransactionStatusLabel } from './utils';

const marketingTransactionStatusMapToBulletType: Record<
    MarketingTransactionStatus,
    BulletStatusProps['type']
> = {
    deposit: 'success',
    withdraw: 'warning',
    transfer: 'success',
};

const TransactionStatusBullet: React.FC<{
    status?: MarketingTransaction['type'];
}> = ({ status }) => {
    if (!status) {
        return <Skeleton width={90} height={52} />;
    }

    return (
        <BulletStatus
            type={marketingTransactionStatusMapToBulletType[status] || 'error'}
            label={getMarketingTransactionStatusLabel(status)}
        />
    );
};

export default TransactionStatusBullet;
